import { FF, P } from '../utils/format';
export const Slider = ({ l, v, fn, min, max, step = 1, f = "n", su = "", c }) => (
  <div style={{ marginBottom: 18 }}>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
      <span style={{ fontSize: 13, color: c.muted, fontWeight: 500 }}>{l}</span>
      <span style={{ fontSize: 13, fontWeight: 600, color: c.fg, fontVariantNumeric: "tabular-nums" }}>
        {f === "$" ? FF(v) : f === "%" ? P(v) : v}{su}
      </span>
    </div>
    <input type="range" min={min} max={max} step={step} value={v}
      onChange={(e) => fn(parseFloat(e.target.value))} style={{ width: "100%" }} />
  </div>
);
